import EntityId from './EntityId';

abstract class Entity<T> {

	protected constructor (private id: EntityId<T>) {
	}

	// Query methods

	public getId () {
		return this.id;
	}

	public hasId () {
		return this.id.getValue() !== null;
	}

	public idEquals (other: Entity<T>) {
		return this.id.equals(other.getId());
	}
}

export default Entity;


// WEBPACK FOOTER //
// ./code/foundation/domain/Entity.ts